import React from "react";
import CTABanner from "../components/CTABanner";
import EraseMyData from "../components/EraseMyData";

const Section = ({ heading, children }) => (
  <div className="mt-10">
    {heading && <h2 className="ek-heading text-2xl md:text-3xl text-black mb-4">{heading}</h2>}
    <div className="ek-body space-y-4 text-[16.5px]">{children}</div>
  </div>
);

const Privacy = () => {
  return (
    <>
      <section className="ek-gradient-dark text-white relative overflow-hidden">
        <div className="ek-star-watermark" />
        <div className="ek-container relative z-10 py-20 md:py-28">
          <div className="ek-eyebrow text-[#A179FA]">Legal</div>
          <h1 className="ek-heading text-4xl md:text-5xl lg:text-6xl text-white mt-4 max-w-4xl leading-tight" data-testid="privacy-headline">
            Ekselens Consulting Privacy Policy
          </h1>
          <p className="text-zinc-200 font-light text-lg mt-6 max-w-3xl">
            How we collect, use and protect personal information at Ekselens Consulting.
          </p>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="ek-container max-w-4xl">
          <p className="ek-body text-lg">
            This website is owned and operated by Ekselens Consulting.
          </p>

          <Section heading="What type of information do we collect?">
            <p>
              We receive, collect and store any information you enter on our website or provide us in any other way. In addition, we collect the Internet protocol (IP) address used to connect your computer to the Internet; login; email address; password; computer and connection information and potentially purchase history via our booking system and/or contact forms.
            </p>
            <p>
              We may use software tools to measure and collect session information, including page response times, length of visits to certain pages, page interaction information, and methods used to browse away from the page. We also collect personally identifiable information (including name, email, password, communications); payment details (including credit card information), comments, feedback, product reviews, recommendations, and personal profile.
            </p>
          </Section>

          <Section heading="How do we collect information?">
            <p>
              When you conduct a transaction (i.e. book an appointment, purchase a product) or contact us on our website, as part of the process, we collect personal information you give us such as your name, address, email address and preferences. Your personal information will be used for the specific reasons stated above only.
            </p>
          </Section>

          <Section heading="Why do we collect such personal information?">
            <p>We collect such non-personal and personal information for the following purposes:</p>
            <ol className="list-decimal list-inside space-y-2 ml-2">
              <li>To provide and operate our services;</li>
              <li>To provide our users with ongoing customer assistance and support;</li>
              <li>To be able to contact our visitors and users with general or personalised service-related notices and promotional messages;</li>
              <li>To create aggregated statistical data and other aggregated and/or inferred non-personal information, which we or our business partners may use to provide and improve our respective services;</li>
              <li>To comply with any applicable laws and regulations.</li>
            </ol>
          </Section>

          <Section heading="How do we store, use, share and disclose your site visitors' personal information?">
            <p>
              Ekselens Consulting is hosted on a secure platform. An online platform that allows us to sell our products and services to you. Your data may be stored through data storage, databases and the general applications we use. We store your data on secure servers behind a firewall.
            </p>
            <p>
              All direct payment gateways offered and used by our company adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers.
            </p>
          </Section>

          <Section heading="How do we communicate with our site visitors?">
            <p>
              We may contact you to notify you regarding your account, to troubleshoot problems with your account, to resolve a dispute, to collect fees or monies owed, to poll your opinions through surveys or questionnaires, to send updates about Ekselens Consulting, or as otherwise necessary to contact you to enforce our User Agreement, applicable national laws, and any agreement we may have with you. For these purposes we may contact you via email, telephone, text messages and postal mail.
            </p>
          </Section>

          <Section heading="How do we use cookies and other tracking tools?">
            <p>
              Ekselens Consulting tracks personal information through the use of cookies. Cookies are small pieces of data stored on a site visitor's browser. They are typically used to keep track of the settings users have selected and actions they have taken on a site.
            </p>
            <p>Ekselens Consulting uses cookies for important reasons, such as:</p>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>To provide a great experience for our visitors and customers.</li>
              <li>To identify our registered members (users who registered to our site).</li>
              <li>To monitor and analyse the performance, operation and effectiveness of our website.</li>
              <li>To ensure our platform is secure and safe to use.</li>
            </ul>
            <p>
              Third-party services, such as Google Analytics or other applications, may place cookies or use other tracking technologies through our services. They have their own policies regarding how they collect and store information. As these are external services, such practices are not covered by our privacy policy.
            </p>
          </Section>

          <Section heading="How can our site visitors withdraw their consent?">
            <p>
              If you don't want us to process your data anymore, please contact us at <a href="mailto:info@ekselens.com" className="text-[#7737F6] hover:underline">info@ekselens.com</a>.
            </p>
            <p>
              For the anonymous maturity-assessment data tied to your browser (in-progress drafts and completed lite scores), you can erase everything immediately using the self-service control below — no email required.
            </p>
            <EraseMyData />
          </Section>

          <Section heading="Privacy policy updates">
            <p>
              We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
            </p>
          </Section>

          <Section heading="Questions and our contact information">
            <p>
              If you would like to access, correct, amend or delete any personal information we have about you, you are invited to contact us via email at <a href="mailto:info@ekselens.com" className="text-[#7737F6] hover:underline">info@ekselens.com</a>.
            </p>
          </Section>

          <LegalSignoff page="privacy" />
        </div>
      </section>

      <CTABanner />
    </>
  );
};

export default Privacy;
